import { ORDER_METHODS } from '../../../../../services/exports/Constants';

export default {
  empty_list: 'Nessun gruppo di modificatori ancora. Creane uno nuovo.',
  fields: {
    name: 'Nome',
    external_id: 'Rif. {{integration}}',
    prices: 'Prezzi',
    available: 'Disponibile',
    status: 'Stato',
    statuses: {
      good: 'Buono',
      bad: 'Cattivo',
      medium: 'Medio',
    },
  },
  order_method_prices: {
    base: 'Base',
    [ORDER_METHODS.pickup]: 'Ritiro',
    [ORDER_METHODS.delivery]: 'Consegna',
    [ORDER_METHODS.room_service]: 'Servizio al tavolo/camera',
  },
  labels: {
    visible: 'Visibile nel menu',
    hidden: 'Tutti nascosti',
  },
  buttons: {
    add_modifier: 'Aggiungi modificatore',
    delete_modifier_one: 'Elimina modificatore',
    delete_modifier_other: 'Elimina modificatori',
    show_modifier_group: 'Mostra gruppo modificatori',
    close_modifier_group: 'Chiudi gruppo modificatori',
    edit: 'Modifica',
    duplicate: 'Duplica',
    history: 'Cronologia',
  },
  toasts: {
    failed_to_duplicate_modifier_group: 'Impossibile duplicare il gruppo modificatori',
    modifier_group_duplicated_successfully: 'Gruppo modificatori duplicato con successo',
    failed_to_duplicate_modifier: 'Impossibile duplicare il modificatore',
    modifier_duplicated_successfully: 'Modificatore duplicato con successo',
  },
};
